export default __webpack_public_path__ + "static/media/loader.9ca08101.gif";